export enum LotteryType {
  HOURLY = 'hourly',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  DEPOSIT = 'deposit',
  FREE = 'free',
  FAST = 'fast',
}
